import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import './index.scss';
import Group from './Group';

class AddConditions extends Component {
  static propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func,
    trigger: PropTypes.string,
  };

  componentDidMount() {
    if (this.props.value === undefined) {
      this.props.onChange(null);
    }
  }

  addGroup() {
    const newGroups = this.props.value.conditions.concat({
      _id: uuidv4(),
      is_group: true,
      type: 'AND',
      conditions: [
        {
          _id: uuidv4(),
          key: null,
          value: [],
          operator: null,
          is_group: false,
        },
      ],
    });
    this.props.onChange(
      Object.assign({}, this.props.value, { conditions: newGroups })
    );
  }

  updateGroupAtIndex(index) {
    return (newGroup) => {
      if (!newGroup.conditions.length) {
        return this.removeGroupAtIndex(index);
      }
      const newGroups = this.props.value.conditions.map((group, i) => {
        if (i !== index) {
          return group;
        }
        return newGroup;
      });
      this.props.onChange(
        Object.assign({}, this.props.value, { conditions: newGroups })
      );
    };
  }

  removeGroupAtIndex(index) {
    const newGroups = this.props.value.conditions.filter((_group, i) => {
      return i !== index;
    });
    this.props.onChange(
      Object.assign({}, this.props.value, { conditions: newGroups })
    );
  }

  renderOpButton() {
    const changeOp = () => {
      if (this.props.value.type === 'AND') {
        this.props.onChange(
          Object.assign({}, this.props.value, { type: 'OR' })
        );
      }
      if (this.props.value.type === 'OR') {
        this.props.onChange(
          Object.assign({}, this.props.value, { type: 'AND' })
        );
      }
    };
    return (
      <div className="AddConditions-operator" onClick={changeOp}>
        {this.props.value.type}
      </div>
    );
  }

  renderGroups() {
    return (
      <div>
        {this.props.value.conditions.map((group, index) => {
          return (
            <div key={index}>
              <Group
                group={group}
                trigger={this.props.trigger}
                onChange={this.updateGroupAtIndex(index)}
                key={index}
              />
              {index !== this.props.value.conditions.length - 1
                ? this.renderOpButton()
                : null}
            </div>
          );
        })}
        <div
          className="AddConditions-add-group gecko-btn gecko-ui-material btn btn-default"
          onClick={this.addGroup.bind(this)}
        >
          <i className="far fa-plus"></i> Add Group
        </div>
      </div>
    );
  }

  hasConditions() {
    return this.props.value !== null && this.props.value !== undefined;
  }

  render() {
    const newValue = {
      is_group: true,
      type: 'AND',
      conditions: [
        {
          _id: uuidv4(),
          is_group: true,
          type: 'OR',
          conditions: [
            {
              _id: uuidv4(),
              key: null,
              value: [],
              operator: null,
              is_group: false,
            },
          ],
        },
      ],
    };
    return (
      <div className="AddConditions">
        <div className="AddConditions-condition-buttons">
          <label>Choose Trigger Type</label>
          <div
            className={`${this.props.value === null ? 'active' : ''}`}
            onClick={() => this.props.onChange(null)}
          >
            Always trigger this workflow
          </div>
          <div
            className={`${
              this.props.value && this.props.value.conditions ? 'active' : ''
            }`}
            onClick={() => this.props.onChange(newValue)}
          >
            Only trigger this workflow if the conditions below are met
          </div>
        </div>
        {this.hasConditions() ? this.renderGroups() : null}
      </div>
    );
  }
}

export default AddConditions;
